// extracted by mini-css-extract-plugin
export default {"container":"item_container__OkqeM","vertical":"item_vertical__UIuvG","subcontainer":"item_subcontainer__reYdM","taglist":"item_taglist__qKrBJ","tag":"item_tag__Q1WJI"};